const timezones = [
  "Eastern Time (US & Canada)",
  "Central Time (US & Canada)",
  "Mountain Time (US & Canada)",
  "Pacific Time (US & Canada)"
]

export default timezones



// WEBPACK FOOTER //
// ./src/features/Account/accountProfile/AccountProfileForm/timezones.js